var React = require('react');

function Linkedin (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},React.createElement("g",{"fill":"#000","fillRule":"nonzero"},React.createElement("g",null,React.createElement("path",{"d":"M137.333 64h-18.666c-3.682 0-6.667 2.985-6.667 6.667v18.666c0 3.682 2.985 6.667 6.667 6.667h18.666c3.683 0 6.667-2.985 6.667-6.667V70.667c0-3.682-2.984-6.667-6.667-6.667zm-14.666 25.333h-4V74.667h4v14.666zm-2-16.357c-1.288 0-2.334-1.053-2.334-2.352s1.046-2.352 2.334-2.352S123 69.325 123 70.624s-1.044 2.352-2.333 2.352zm18 16.357h-4v-7.472c0-4.49-5.334-4.15-5.334 0v7.472h-4V74.667h4v2.353c1.862-3.448 9.334-3.703 9.334 3.301v9.012z","transform":"translate(-242 -2214) translate(130 2150)"})))));
}

Linkedin.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32"};

module.exports = Linkedin;

Linkedin.default = Linkedin;
